import axios from '@/axiosInstance.ts'
import axiosOriginalInstance, {AxiosProgressEvent} from 'axios'

export const httpGetAssignmentUploadedImages = ({urlParams}: {urlParams: {assignmentId: number}}) =>
    axios.get(`/assignments/${urlParams.assignmentId}/image`)

/*Delete uploaded images bulk*/
interface HttpBulkDeleteUploadedImagesOptions {
    urlParams: {assignmentId: number}
    params: {ids: number[]}
}
export const httpBulkDeleteUploadedImages = ({urlParams, params}: HttpBulkDeleteUploadedImagesOptions) =>
    axios.delete(`/assignments/${urlParams.assignmentId}/image`, {params})

/*Upload images*/
interface HttpUploadImageOptions {
    url: string
    payload: File
    onUploadProgress: (progressEvent: AxiosProgressEvent) => void
}
export const httpUploadImage = ({url, payload, onUploadProgress}: HttpUploadImageOptions) =>
    axiosOriginalInstance.put(url, payload, {onUploadProgress})

/*Confirm upload image*/
export const httpConfirmUploadImage = ({urlParams}: {urlParams: {assignmentId: number; mediaId: number}}) =>
    axios.patch(`/assignments/${urlParams.assignmentId}/image/${urlParams.mediaId}/upload-completed`)

/*Presign bulk images*/
interface HttpGetPresignBulkImagesOptions {
    urlParams: {assignmentId: number}
    payload: {medias: string[]}
}
export const httpGetPresignBulkImages = ({urlParams, payload}: HttpGetPresignBulkImagesOptions) => {
    return axios.post(`/assignments/${urlParams.assignmentId}/image/bulk/upload`, payload)
}
